import React from 'react';
import { NavLink } from 'react-router-dom';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import { blogs } from './../../assets/js/blogData';

// const recentPost = [
//     {
//         image: require('./../../images/blog/recent-blog/pic1.jpg'),
//         title: 'Nowy skatepark w Łodzi zachwyca mieszkańców',
//         date: '12 Jan',
//         comment: '20 komentarzy'
//     },
//     {
//         image: require('./../../images/blog/recent-blog/pic2.jpg'),
//         title: 'Otwarcie skateparku w Poznaniu z udziałem znanych skaterów',
//         date: '10 Jan',
//         comment: '15 komentarzy'
//     },
//     {
//         image: require('./../../images/blog/recent-blog/pic3.jpg'),
//         title: 'Międzynarodowe zawody skateboardingowe w Polsce',
//         date: '25 Mar',
//         comment: '09 komentarzy'
//     }
// ]

const logos = [
    { image: require('./../../images/testimonials/babimost.png') },
    { image: require('./../../images/testimonials/celestynow.png')},
    { image: require('./../../images/testimonials/gdansk.png') },
    { image: require('./../../images/testimonials/grojec.png') },
    { image: require('./../../images/testimonials/jaroslaw.png') },
    { image: require('./../../images/testimonials/jedlicze.png') },
    { image: require('./../../images/testimonials/lebork.png') },
    { image: require('./../../images/testimonials/minsk_mazowiecki.png') },
    { image: require('./../../images/testimonials/olsztyn.png') },
    { image: require('./../../images/testimonials/radymno.png') },
    

]

const galleryImages = [
    { 
        image: require('./../../images/gallery/pic1.jpg') ,
        thumb: require('./../../images/gallery/thumb/pic1.jpg')
    },
    { 
        image: require('./../../images/gallery/pic2.jpg') ,
        thumb: require('./../../images/gallery/thumb/pic2.jpg')
    },
    { 
        image: require('./../../images/gallery/pic3.jpg') ,
        thumb: require('./../../images/gallery/thumb/pic3.jpg')
    },
    { 
        image: require('./../../images/gallery/pic4.jpg') ,
        thumb: require('./../../images/gallery/thumb/pic4.jpg')
    },
    { 
        image: require('./../../images/gallery/pic5.jpg') ,
        thumb: require('./../../images/gallery/thumb/pic5.jpg')
    },
    { 
        image: require('./../../images/gallery/pic6.jpg') ,
        thumb: require('./../../images/gallery/thumb/pic6.jpg')
    },
    { 
        image: require('./../../images/gallery/pic7.jpg') ,
        thumb: require('./../../images/gallery/thumb/pic7.jpg')
    },
    { 
        image: require('./../../images/gallery/pic8.jpg') ,
        thumb: require('./../../images/gallery/thumb/pic8.jpg')
    }
]

class BlogSidebar extends React.Component {
    
    componentDidMount() {
        function loadScript(src) {

            return new Promise(function (resolve, reject) {
                var script = document.createElement('script');
                script.src = src;
                script.addEventListener('load', function () {
                    resolve();
                });
                script.addEventListener('error', function (e) {
                    reject(e);
                });
                document.body.appendChild(script);
                document.body.removeChild(script);
            })
        };

        loadScript('./assets/js/masonary.js');

    };

    render() {
        const options = {
            loop:true,
            autoplay:true,
            items:1,
            nav:false,
            dots:true,
            navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
        };
        return (
            <>
                <link rel="stylesheet" type="text/css" href="./assets/css/style.css" />
                <div className="col-lg-4 col-md-4">
                    <aside className="side-bar">
                        {/* SEARCH */}
                        <div className="widget bg-white ">
                            <h4 className="widget-title ">Search</h4>
                            <div className="search-bx">
                                <form role="search" method="post" action="">
                                    <div className="input-group">
                                        <input name="news-letter" type="text" className="form-control bg-gray" placeholder="Write your text" />
                                        <span className="input-group-btn bg-gray">
                                          <button  type="submit" className="btn"><i className="fa fa-search" /></button>
                                        </span>
                                    </div>
                                </form>
                            </div>
                        </div>
                        {/* ABOUT AUTHOR */}
                        <div className="widget bg-white">
                            <h4 className="widget-title ">O autorze</h4>
                            <div className="widget-post m-b15">
                                <img src={require("./../../images/projects/square/pic4.jpg")} alt="" className="img-responsive" />
                            </div>
                            <p>Pasjonat skateboardingu, specjalista od budowy skateparków. Zajmuje się projektowaniem i tworzeniem przestrzeni miejskich, które łączą ludzi i promują aktywny tryb życia. Dedykowany tworzeniu zrównoważonej przyszłości poprzez innowacyjne projekty i ekologiczną architekturę. </p>
                        </div>
                        {/* RECENT POSTS */}
                        <div className="widget bg-white  recent-posts-entry">
                            <h4 className="widget-title  ">Recent Posts</h4>
                            <div className="section-content">
                                <div className="widget-post-bx">
                                    {blogs.map((item, index) => (
                                        <div className="widget-post clearfix">
                                            <div className="mt-post-media">
                                                <img src={item.recentPostImg80x80} alt={item.recentPostImgAlt}/>
                                            </div>
                                            <div className="mt-post-info">
                                                <div className="mt-post-meta">
                                                    <ul>
                                                        <li className="post-author">{item.date}</li>
                                                        <li className="post-comment"> {item.comment}</li>
                                                    </ul>
                                                </div>
                                                <div className="mt-post-header">
                                                    <h6 className="post-title">{item.title}</h6>
                                                </div>
                                            </div>
                                        </div>

                                    ))}
                                </div>
                            </div>
                        </div>
                        {/* NEWSLETTER */}
                        {/* <div className="widget widget_newsletter-2 bg-white  ">
                            <h4 className="widget-title  ">Newsletter</h4>
                            <div className="newsletter-bx p-a30">
                                <div className="newsletter-icon">
                                    <i className="fa fa-envelope-o" />
                                </div>
                                <div className="newsletter-content">
                                    <p>Subscribe to our mailing list to get the update to your email.</p>
                                </div>
                                <div className="m-t20">
                                    <form role="search" method="post" action="">
                                        <div className="input-group">
                                            <input name="news-letter" className="form-control" placeholder="WPROWADŹ SWÓJ EMAIL" type="text" />
                                            <span className="input-group-btn">
                                              <button  type="submit" className="site-button"><i className="fa fa-paper-plane-o" /></button>
                                            </span>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div> */}
                        {/* OUR CLIENT */}
                        <div className="widget">
                            <h4 className="widget-title ">Our Client</h4>
                            <OwlCarousel className="owl-carousel widget-client p-t10" {...options}>
                                {logos.map((item, index) => (
                                    <div className="item" key={index}>
                                        <div className="ow-client-logo">
                                            <div className="client-logo">
                                                <NavLink to={"#"}><img src={item.image} alt="" /></NavLink>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                                
                            </OwlCarousel>
                        </div>
                        {/* OUR GALLERY  */}
                        <div className="widget widget_gallery mfp-gallery">
                            <h4 className="widget-title  ">Our Gallery</h4>
                            <ul>
                                {galleryImages.map((item, index) => (
                                    <li key={index}>
                                        <div className="mt-post-thum">
                                            <a href={item.image} className="mfp-link"><img src={item.thumb} alt=""/></a>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        {/* TAGS */}
                        <div className="widget bg-white  widget_tag_cloud">
                            <h4 className="widget-title">Tags</h4>
                            <div className="tagcloud">
                            
                            <ul className='tag-list'>
                            <li><NavLink to="#">Projektowanie</NavLink></li>
        <li><NavLink to="#">Budowa</NavLink></li>
        <li><NavLink to="#">Rampy</NavLink></li>
        <li><NavLink to="#">Wydarzenia</NavLink></li>
        <li><NavLink to="#">Społeczność</NavLink></li>
        <li><NavLink to="#">Skaterzy</NavLink></li>
        <li><NavLink to="#">Innowacje</NavLink></li>
        <li><NavLink to="#">Publiczne Przestrzenie</NavLink></li>
        <li><NavLink to="#">Umiejętności</NavLink></li>
        <li><NavLink to="#">Konserwacja</NavLink></li>
        <li><NavLink to="#">Trendy</NavLink></li>
        <li><NavLink to="#">Skateparki</NavLink></li>
        <li><NavLink to="#">Skateurbanizm</NavLink></li>
        <li><NavLink to="#">Architektura</NavLink></li>
        <li><NavLink to="#">Przestrzeń Publiczna</NavLink></li>
        <li><NavLink to="#">Technologia</NavLink></li>
        <li><NavLink to="#">Historia</NavLink></li>
        <li><NavLink to="#">Wydarzenia</NavLink></li>
        <li><NavLink to="#">Skate Life</NavLink></li>
</ul>
                            </div>
                        </div>
                    </aside>
                </div>
            </>
        );
    }
};

export default BlogSidebar;